import tonStyles from './../ton.json'

export default {
  paginatorPosition: 'bottom',
  paginatorColor: tonStyles.colors.PrimaryBlack,
  paginatorBottomSpacing: 0,
  paginatorTopSpacing: 16
}
